/**
=========================================================
* Argon Dashboard 2 MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-material-ui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
 


import Card from "@mui/material/Card";

// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";


// Argon Dashboard 2 MUI examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "examples/Tables/Table";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import breakpoints from "assets/theme/base/breakpoints";

// Data
// import authorsTableData from "layouts/tables/data/authorsTableData";
import projectsTableData from "layouts/tables/data/projectsTableData";
// import tutorTableData from "Views/people/tutor/data/tutorTableData";
// import TestUserTableData from "Views/TestUser/data/TestUserTableData"

// import IncomeBreakDownTabelData from "Views/Report/IncomeBreakDown/data/IncomeBreakDownTableData" 

import IncomeOverTimeTableData from "Views/Report/IncomeOverTime/data/IncomeOverTimeTableData"
import { useState,useEffect } from "react";
import ApnaTabs from "components/ApnaTabs/ApnaTabs";
import dayjs from "dayjs";
import CustomDatePicker from "components/CustomDatePicker/CustomDatePicker";
import ArgonButton from "components/ArgonButton";
import { height, width } from "@mui/system";

function Tables() {
  const { columns, rows } = IncomeOverTimeTableData;

    const tabsData = [
      {label:"Last 7 day",content:""},
      {label:"Monthly",content:""},
      {label:"Quarterly",content:""},
      {label:"Yearly",content:""},
    ]

    const [dob, setDob] = useState(dayjs());

  return (
    <DashboardLayout>
      <DashboardNavbar/>

      <ArgonBox py={3}>
        <ArgonBox mb={3}>
          <Card>
            <ArgonBox  p={3}>
              <ArgonTypography mb={2}  variant="h6" fontWeight="medium">Income Over Time</ArgonTypography>
               <ArgonBox display="flex" justifyContent="space-between" alignItems="center" gap={2} >
              
              <ArgonBox sx={{height:"36px"}}>
                <ApnaTabs  tabsData={tabsData}/>
              </ArgonBox>
                

                 <ArgonBox  sx={{height:"36px"}} display="flex" gap={2} alignItems="center">
                     <CustomDatePicker
                       label="From"
                      value={dob}
                      onChange={(newValue) => setDob(newValue)}
                      width={150}
                      maxDate={dayjs()} // future date disable
                    />
                         <CustomDatePicker
                      label="To"
                      value={dob}
                      onChange={(newValue) => setDob(newValue)}
                      width={150}
                      maxDate={dayjs()} // future date disable
                    />
                
                      <ArgonButton variant="contained" color="primary" size="small" style={{marginLeft:"10px"}}>
                      Filter
                    </ArgonButton>
                   </ArgonBox>

               </ArgonBox>
            </ArgonBox>
            <ArgonBox
              sx={{
                "& .MuiTableRow-root:not(:last-child)": {
                  "& td": {
                    borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                      `${borderWidth[1]} solid ${borderColor}`,
                  },
                },
              }}
            >
              <Table columns={columns} rows={rows} />
            </ArgonBox>
          </Card>
        </ArgonBox>
        
      </ArgonBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Tables;
